import { EstimationArrivalEndpoints } from '@/modules/seller-management/estimation-arrival/api/estimationArrivalEndpoints'

/**
 * Estimation Arrival endpoint instance
 * instantiate Estimation Arrival api class with a different api path
 */
export const estimationArrivalEndpoints = new EstimationArrivalEndpoints()
